import React, { useMemo } from "react";
import { IconApp } from "./IconApp";
import { DATA_DEFINITION, DATA_DEFINITION_INDEX } from "./Options/students/OptionsStatus";

export const StudentStatusIcon = ({
    status,
    iconClassName = "",
    iconSizeClassName = "",
}) => {
    const { iconColor, definition } = useMemo(() => {
        let color = "";
        switch (status) {
            case "NORMAL":
            case "EQUIVALENTE":
            case "PENDIENTE DE INGRESO":
            case "PASANTE":
            case "INTERNO":
                color = "#58D68D";
                break;
            case "SERVICIO SOCIAL":
            case "EGRESADO":
            case "GRADUADO":
            case "TITULADO":
                color = "#3FA6EA";
                break;
            case "SOLICITANTE":
                color = "#FFC300";
                break;
            case "DUPLICADO":
                color = "#FF5733";
                break;
            case "SUSPENDIDO":
            case "BAJA TEMPORAL":
            case "BAJA ACADEMICA":
            case "BAJA ADEUDO BIBLIOTECA":
            case "BAJA POR DOCUMENTOS":
            case "BAJA POR ADEUDO":
            case "BAJA INFORMAL":
            case "BAJA DEFINITIVA":
                color = "#C70039";
                break;
            default:
                color = "";
        }

        const definition = DATA_DEFINITION_INDEX?.[status];

        return { iconColor: color, definition };
    }, [status]);

    return (
        <IconApp
            iconClassName={`fa-solid ${
                iconClassName ? iconClassName : "fa-circle-info"
            } ${iconSizeClassName ? iconSizeClassName : "fa-xl"}`}
            color={iconColor}
            description={definition}
        />
    );
};
